import React from 'react';
import { BuiltWith } from '../components/home/BuiltWith';
import { CtaBand } from '../components/home/CtaBand';
import { Process } from '../components/home/Process';
import { ServicePillar } from '../components/services/ServicePillar';
import { ServicesHero } from '../components/services/ServicesHero';
import { serviceDetails } from '../data/serviceDetails';
export function Services() {
  return <>
      <ServicesHero data-id="element-1010" data-mp="153l0je8b61n" />
      {serviceDetails.map((service, index) => <ServicePillar key={service.index} service={service} tone={index % 2 === 0 ? 'surface' : 'canvas'} data-id="element-1011" data-mp="3t9nw6mnczxyk" data-mpi={index} />)}
      <Process data-id="element-1012" data-mp="b3j3jxz6x6zj" />
      <BuiltWith data-id="element-1013" data-mp="b1yir02oh2ev" />
      <CtaBand data-id="element-1014" data-mp="64ycao1x1xn8" />
    </>;
}